export enum CustomerPagePath {
  Root = '/',
  Home = '/home',
  ProductList = '/productList',
  ProductDetail = '/productDetail',
  OrderStatus = '/orderStatus',
  AccountAsset = '/accountAsset',
  AccountTransactionHistory = '/accountTransactionHistory',
  Notice = '/notice',
  AccountInfo = '/accountInfo',
  TransferDistination = '/transferDistination',
  Contact = '/contact',
  Login = '/login',
  SendSMS = '/sendSMS',
  ReissuePassword = '/reissuePassword',
  ChangePassword = '/changePassword',
  SecuritySetting = '/securitySetting',
  Maintenance = '/maintenance',

  //口座開設
  AddvanceQuestion = '/advanceQuestion',
  ConsentSecurities = '/consentSecurities',
  ConsentTrust = '/consentTrust',
  CustomerInfo = '/customerInfo',
  DepositAccount = '/depositAccount',
  Employment = '/employment',
  InvestmentInfo = '/investmentInfo',
  RequestConfirm = '/requestConfirm',
  RequestComplete = '/requestComplete',

  // MFAのリダイレクト先
  MFARedirect = '/mfaredirect',
}

//　ログインが必要なパス 画面が増えた場合は追加必須
const needLoginPathList = [
  CustomerPagePath.Home,
  CustomerPagePath.ProductList,
  CustomerPagePath.ProductDetail,
  CustomerPagePath.OrderStatus,
  CustomerPagePath.AccountAsset,
  CustomerPagePath.AccountTransactionHistory,
  CustomerPagePath.Notice,
  CustomerPagePath.AccountInfo,
  CustomerPagePath.TransferDistination,
  CustomerPagePath.Contact,
  CustomerPagePath.SecuritySetting,
];

export const checkNeedLoginPath = (pathName: string) => {
  return needLoginPathList.some((x) => x === pathName);
};
